import { useEffect, useState } from "react";
import SlbButton from "../controls/button";
import SlbPopUp from "../controls/slbPopUp";
import { useDispatch } from "react-redux";
import { getBulkUploadTemplate, uploadBulkDataTemplate } from "../../store/bulk/downloadTemplateSlice";

import { BulkUploadFile, UploadBulkUsers } from "./bulkUploadFile";
import { ComponentLoader } from "../loader/componentLoader";
import { getConfiguredLabel } from "../../common/commonHelper";
import { addBulkUserHeader, addButton, blankCellsBulkError, bulkUploadButton, bulkUsersSavedToasterMessage, bulkUsersSavedToasterTitle, cancelButton, DocumentsPage, downloadIcon, downloadTemplateButton, downloadTemplateMsg1, downloadTemplateMsg2, downloadTemplateMsg3, downloadTemplateMsg4, duplicateEmailsBulkError, duplicateEmailsInExcelBulkError, errorIcon, fileUploadFailed, goToDocs, HomePage, howToUpload, iIcon, invalidEmailsInExcelBulkError, invalidExcelBulkError, invalidFileBulkError, invalidRolesBulkError, pleaseWait, saveToasterMessage, saving, supported, svg, warning } from "../../common/labelConstants";
import { AppToast } from "../../lib/toast";
const _props = {

}
export function BulkUserUpload(props = _props) {
    const [showPopUp, setShowPopUp] = useState(false);
    const [fileList_Data, setFileList] = useState([]);
    const [isMounted, setIsMounted] = useState(true);
    const [isUploadComplete, setIsUploadComplete] = useState(false);
    const [showProgress, setShowProgress] = useState(false)
    const slbSearchConfig = window.slbConfig;
    const [errors, setErrors] = useState([])
    const dispatch = useDispatch();
    useEffect(() => {
        return () => {
            setIsMounted(false)
        }
    }, [])
    const buttons = {
        cancel: {
            label: getConfiguredLabel(DocumentsPage, cancelButton), onClick: (event) => {
                setErrors([])
                setShowPopUp(false)
            }
        },

        ok: {
            disabled: !isUploadComplete || fileList_Data.length === 0 || errors.length > 0,
            label: getConfiguredLabel(DocumentsPage, addButton),
            onClick: (event) => {
                handleSubmit()
            }
        }

    }
   
    const allErrorList = [
        {name : "invalidFile" , message :  getConfiguredLabel(DocumentsPage,invalidFileBulkError)},
        {name : "invalidExcel" ,message :getConfiguredLabel(DocumentsPage,invalidExcelBulkError)},
        {name : "blankCells" ,message : getConfiguredLabel(DocumentsPage,blankCellsBulkError)},
        {name : "invalidRoles" , message :  getConfiguredLabel(DocumentsPage,invalidRolesBulkError)},
        {name : "duplicateEmailsInExcel" , message :  getConfiguredLabel(DocumentsPage,duplicateEmailsInExcelBulkError)},
        {name : "invalidEmailsInExcel" , message : getConfiguredLabel(DocumentsPage,invalidEmailsInExcelBulkError)},
        {name : "duplicateEmails" , message : getConfiguredLabel(DocumentsPage,duplicateEmailsBulkError)}

    ]
    const handleSubmit = () => {
        setShowProgress(true)
        const fileItem = fileList_Data[0]
        let serverId = fileItem.file.serverId;
        let fileName = fileItem.fileName;
        let fileExtension = fileItem.fileExtension;

        const payload = {
            clientId: slbSearchConfig.accountId,
            serverId: serverId,
            originalFileName: fileName,
            fileExtension: fileExtension
        }

        dispatch(uploadBulkDataTemplate(payload))
            .then((resp) => {
                if (isMounted === true) {

                    if (resp.payload.status === 200) {
                        AppToast.Toast.success({ title: getConfiguredLabel(DocumentsPage, bulkUsersSavedToasterTitle), message: getConfiguredLabel(DocumentsPage, bulkUsersSavedToasterMessage) })

                        setShowProgress(false)
                        setErrors([])

                        setShowPopUp(false)
                    } else if (resp.payload.status === 400) {
                        AppToast.Toast.error({ title: getConfiguredLabel(DocumentsPage, warning), message: getConfiguredLabel(HomePage, fileUploadFailed) })

                        setShowProgress(false)
                        setErrors(resp.payload.data.errors)

                    } else {

                    }
                }
            })

    }
    
    let filteredErrorList =errors.length > 0 && errors.map(x=>{
        
        const isFound = allErrorList.find(element => {
          if (element.name === x) {
          return element.message
          }
        });
        return isFound
        })

    const handleDownload = () => {
        const payload = {
            clientId: slbSearchConfig.accountId
        }
        dispatch(getBulkUploadTemplate(payload))
            .then((resp) => {

            })


    }
    return <>
        <SlbPopUp className="saving_file_modal" hideHeader={true} hideFooter={true} show={showProgress}>
            <div>
                <div className="file_modal_title">{getConfiguredLabel(HomePage, saving)}</div>
                <div className="file_modal_text">{getConfiguredLabel(HomePage, pleaseWait)}</div>
                <ComponentLoader />
            </div>
        </SlbPopUp>
        <SlbButton variant="primary" className="calcel_btn" onClick={(e) => {
            setShowPopUp(true);

        }}>{getConfiguredLabel(DocumentsPage, bulkUploadButton)}</SlbButton>

        <SlbPopUp buttons={buttons} title={getConfiguredLabel(DocumentsPage, addBulkUserHeader)} hideHeader={false} hideFooter={false} show={showPopUp}>

            <div className="bulkUploadDownloadBtn">
                <div className="d-flex justify-content-between">
                    <div className="bulkUploadHead">
                        <b>{getConfiguredLabel(DocumentsPage, howToUpload)}</b>
                        <p>{getConfiguredLabel(DocumentsPage, downloadTemplateMsg1)}</p>
                    </div>
                    <div>
                        <SlbButton variant="primary" onClick={(e) => {
                            handleDownload()
                        }}>
                            <span class="download_icon mr-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.167" height="14.423"
                                    viewBox="0 0 16.167 14.423">
                                    <path id="Download_icon" data-name="Download icon"
                                        d="M969.1,322.588l-3.037-3.008a.985.985,0,0,1,0-1.4,1.009,1.009,0,0,1,1.417,0l1.258,1.247c.046-1.023,0-5.52,0-5.52s.171-.8.859-.8-.181-.024.413-.024.852.8.852.8-.116,2.057-.116,5.644l1.32-1.344a1.008,1.008,0,0,1,1.417,0,.985.985,0,0,1,0,1.4l-2.966,3a1.008,1.008,0,0,1-1.417,0Zm-5.1,1.917a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-3h2v4a2,2,0,0,1-2,2H964a2,2,0,0,1-2-2l-.167-4h2Z" transform="translate(-961.833 -313.082)" fill="#3265AA"></path>
                                </svg>
                            </span>
                            {getConfiguredLabel(DocumentsPage, downloadTemplateButton)}
                        </SlbButton>
                    </div>
                </div>
                <div className="bulkUploadHead">
                    <p>{getConfiguredLabel(DocumentsPage, downloadTemplateMsg2)}</p>                   
                    <p>{getConfiguredLabel(DocumentsPage, downloadTemplateMsg4)}</p>
                </div>
                
                <UploadBulkUsers handleSetErrors={setErrors} errorsList={filteredErrorList} handleSetFileList={setFileList} handleSetUploadComplete={setIsUploadComplete} />
            </div>


        </SlbPopUp>
    </>
}